// extracted by css-extract-rspack-plugin
export default {"icon":"wpM0i1pdceo7Mz42"};